import styled from "styled-components";
import { Wrapper } from "AppReact";

const Content = styled.div`
  position: absolute;
  background: #FFFFFF;
  border: 1px solid #E3E3E3;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  z-index: 10;
  margin-top: 5px;

  max-height: 450px;
  min-width: 220px;
  overflow: auto;

  scrollbar-width: thin;
  scrollbar-color: #E3E3E3 transparent;

  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
  ::-webkit-scrollbar-track {
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background: #D2D2D2;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #D2D2D2;
  }
`;

export default Wrapper(Content)